/**
 * PRJ1417943 - Integration Accelerator
 * Dynamically loads agency error maps from agencies config
 * Changed from static imports (bon, dps, tdlr, etc.)
 */

// Agencies config
import agencies from '../../../../agency-config/agencies';

// Returns a synchronously built errors object using require for dynamic import
export function getAgencyErrors() {
  const errors = {};
  const agenciesArr = Array.isArray(agencies) ? agencies : Object.values(agencies);
  agenciesArr.forEach(({ agency }) => {
    const { agencyShortName, importPath } = agency;
    const slug = String(agencyShortName || '').toLowerCase();
    if (importPath) {
      try {
        // Use require for synchronous dynamic import
        // eslint-disable-next-line global-require, import/no-dynamic-require
        const mod = require(`./${importPath.replace('./', '')}`);
        errors[slug] = mod[slug] || mod.default || mod;
      } catch (e) {
        // Optionally log or handle missing module
      }
    } else {
      errors[slug] = {};
    }
  });
  return errors;
}
